import type { Ref } from 'react';
import { Modal } from '@/ui/components/base';
import { AllGameRounds } from './AllGameRounds/AllGameRounds';

interface PlayHistoryProps {
    onBack: () => void;
    ref?: Ref<HTMLDivElement>;
}

export const PlayHistory = ({ ref, onBack }: PlayHistoryProps) => {
    return (
        <Modal.Content className="play-history" ref={ref}>
            <Modal.Header onBack={onBack}>Play History</Modal.Header>
            <Modal.Body>
                <AllGameRounds />
            </Modal.Body>
        </Modal.Content>
    );
};
